module.exports = __webpack_public_path__ + "img/life-after-death.8f1b5f12.jpg";